import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { BillingModuleTypes } from '@fi-shared/models/module-types';
import { createMap } from '@fi-shared/utils/create-map';

const moduleTypesMap = createMap(BillingModuleTypes, 'Id');

function fiBillingModuleTypeName(id, appText: AppTextService) {
    if (moduleTypesMap.hasOwnProperty(id)) return appText.get(moduleTypesMap[id].TextId);

    throw 'FI: Unknown module type ' + id;
}

@Pipe({
    name: 'fiBillingModuleTypeName',
    standalone: false,
})
export class BillingModuleTypeNamePipe implements PipeTransform {
    constructor(private appText: AppTextService) {}

    transform(value: any, args?: any): any {
        return fiBillingModuleTypeName(value, this.appText);
    }
}
